import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { adminRouteAccess } from "@/lib/admin";

export function AdminRoute({ children }) {
  const { user } = useAuth();
  const access = adminRouteAccess(user);

  if (access === "LOADING") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#121214] text-sm font-semibold text-zinc-400" data-testid="admin-auth-loading">
        Checking Admin access…
      </div>
    );
  }

  if (access === "REDIRECT") return <Navigate to="/" replace />;
  return children;
}
